import { render, staticRenderFns } from "./swiperCard.vue?vue&type=template&id=295ebce4&scoped=true&"
import script from "./swiperCard.vue?vue&type=script&lang=js&"
export * from "./swiperCard.vue?vue&type=script&lang=js&"
import style0 from "./swiperCard.vue?vue&type=style&index=0&id=295ebce4&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "295ebce4",
  null
  
)

export default component.exports